import React, { useRef, useState } from "react"
import { useSelector } from "react-redux"
import SettingIconWhite from '../../../../../assests/header/icons/settings-icon-white.png'
import SettingIconDark from '../../../../../assests/header/icons/settings-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import Settings from "../../HeaderDashboard/Settings"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import { onKeyDown } from "../../../../../service"


const SettingBtn = () => {

    const [showSetting, setShowSetting] = useState(false)
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        setShowSetting(false);
    });

    function open(e) {
        setShowSetting(prevShowSetting => !prevShowSetting)
    }

    return (
        <div ref={popupRef} className={` ${!showSetting ? classes.Icon : classes.OpenIconImg}`}>
            <img src={` ${showSetting ? SettingIconDark : SettingIconWhite}`} alt='SettingsIcon' className={classes.IconImg} onClick={(e) => open(e)}  tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))}/>
            {showSetting && <IconHeaderBackground title={texts.setting} close={() => setShowSetting(false)}><Settings /></IconHeaderBackground>}
        </div>
    )
}

export default SettingBtn